<template>
    <div id="useraddnew">
        <div id="header1">
            <!--<img src="../../assets/news/header/TOG_Logo_500X70_3.jpg" alt="">-->
            <img src='/images/web_img/TOG_Logo_500X70_3.jpg' alt="">
            <div>
                {{now1}}
            </div>
            <div class="topbar">
                <router-link to="/">News homepage</router-link>
            </div>
        </div>

        <div id="container">
            <div>
                <div>
                    <p>Your sharing</p>
                </div>
                
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

                    <el-form-item label="News type" prop="type">
                        <el-select v-model="ruleForm.type" placeholder="Please select the type of news">
                            <el-option v-for="t in newsTypes" :key="t.id" :label="t.id + '.' + t.name" :value="String(t.id)"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="新闻标题" prop="title">
                        <el-input type="textarea" v-model="ruleForm.title"></el-input>
                    </el-form-item>

                    <div style="margin: 0 10px 20px 10px">
                        <UserAddNewsEditor></UserAddNewsEditor>
                    </div>



                    <el-form-item prop="author">
                        <label slot="label">Author</label>
                        <!-- <el-input v-model="ruleForm.author" :disabled="true"></el-input> -->
                        <el-input v-model="ruleForm.author"></el-input>
                    </el-form-item>

                    <el-form-item prop="mobile">
                        <label slot="label">Phone number</label>
                        <el-input v-model="ruleForm.mobile"></el-input>
                    </el-form-item>

                    <!-- <el-form-item label="图片链接" prop="pic">
                        <el-input v-model="ruleForm.pic" :disabled="true"></el-input>
                    </el-form-item> -->

                    <!-- <el-form-item label="锁定新闻" prop="locked"> -->
                        <!-- <el-switch v-model="ruleForm.locked"></el-switch> -->
                        <!-- <el-switch v-model="locked" disabled></el-switch>
                    </el-form-item> -->

                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">Submit</el-button>
                        <el-button @click="resetForm('ruleForm')">Reset</el-button>
                    </el-form-item>
                </el-form>

            </div>
        </div>
    </div>
</template>

<script>

import UserAddNewsEditor from './UserAddNewsEditor.vue';
import clock from "@/mixins/clock";
import { NEWS_TYPES } from "@/constants/newsTypes";
import { request } from "@/api/http";

// 正文里图片路径的历史前缀，提交前统一去掉（不再直接改 store）
const HTML_ROOT_FIX = '../../../public_html';
function normalizeContent(html) {
    return html ? html.split(HTML_ROOT_FIX).join('') : '';
}

export default {
    components: {
        UserAddNewsEditor,
    },

    mixins: [clock],

    data () {
        const validateMobile = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please enter your phone number'));
            } else if (!/^1[3-9]\d{9}$/.test(value)) {
                callback(new Error('Please enter a valid phone number'));
            } else {
                callback();
            }
        }
        return {
            newsTypes: NEWS_TYPES,
            ruleForm: {
                type: '',
                title: '',
                author: '',
                pic: '',
                mobile: '',
            },
            rules: {
                type: [
                    { required: true, message: 'Please select the type of news', trigger: 'change' }
                ],
                title: [
                    { required: true, message: 'Please fill in the news title', trigger: 'blur' },
                    { max: 200, message: 'Less than 200 characters in length', trigger: 'blur' }
                ],
                mobile: [
                    { validator: validateMobile, trigger: 'blur' }
                ],
            },
        }
    },
    computed: {
        // 监听编辑器正文，取第一张图片作为缩略图
        listenstore(){
            return this.$store.state.msg1;
        }
    },
    watch: {
        listenstore:function(){
            const html = this.$store.state.msg1 || '';
            const picPath = (html.split('<img src="')[1] || '').split('" title="')[0];
            this.ruleForm.pic = picPath;
        },
    },

    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false;
                }
                request('/CalawaEnServlet/NewsServlet', {
                    action: 'addNews',
                    type: this.ruleForm.type,
                    title: this.ruleForm.title,
                    content: normalizeContent(this.$store.state.msg1),
                    pic: this.ruleForm.pic,
                    author: this.ruleForm.author,
                    mobile: this.ruleForm.mobile,
                    locked: 1,
                }).then(() => {
                    this.$alert('Submission successful', 'TempleOfGood', {
                        confirmButtonText: 'OK',
                        callback: () => {
                            this.$router.push({ name: 'index' });
                        }
                    });
                }).catch(() => {
                    this.$message.error('Submission failed, please try again');
                });
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
}
</script>

<style lang="scss" scoped>
#useraddnew{
    width: 100%;
    height: auto;

    #header1{
        width: 1000px;

        background-color: white;

        text-align: center;

        margin: 0 auto;

        img{
            display: block;
            margin: 0 auto;
        }
        div{
            width: auto;
            height:30px;
            margin: 20px auto 0 auto;
            padding-bottom: 20px;
            text-align: center;
            // display: inline-block;
        }
        .topbar{
            width: 1000px;
            height: 42px;

            background-color: #12278D;

            margin:0 auto 0 auto;
            padding: 0;
            overflow: auto; 

            a{
                width: 120px;
                height: 32px;
                
                color: white;

                display: block;

                float: left;
                padding-top: 10px;

                &:hover{
                    text-decoration:none;
                    cursor: pointer;
                }
            }
        }
        
    }

    #container{
        width: 980px;
        height: 900px;

        padding: 10px 10px 10px 10px;

        background-color: #ccc;

        margin: 0 auto;
        
        >div{
            width: 980px;
            height: 900px;

            background-color: white;

            >div:nth-child(1){
                width: 100%;
                height: 80px;
                line-height: 80px;

                font-size: 30px;
                font-weight: 600;
            }

            .el-form{
                width: 460px;

                text-align: left;

                // margin-top: 30px;

                div:nth-child(3){
                    width: 1083px;

                    margin: 20px 0 30px 0;
                }
            }
        }
    }
}
</style>